//#region IMPORT
import { useState, useRef } from 'react';
import SAT_BASIC_04 from './SAT_BASIC_05';
import { useNavigate } from 'react-router-dom';
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { Loading } from '../../../../Components/MUIs';
import useDelete from '../../../../hooks/useDeleteN';
import { closeLoading, showLoading } from '../../../../Reducer/LoadingReducer';
import {
  useDelete1,
  useDelete2,
  useSave1,
  useSave2,
  useSearch1,
  useSearch2,
  useSearch3,
  useSearchCode,
} from './SAT_BASIC_05_QUERY';
import { useSave } from '../../../../hooks/useSaveN';
import { SAT_BASIC_05_Schema } from './SAT_BASIC_05_Schema';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
//#endregion

// 화면 MENU_ID
const SCREEN_MENU_ID = 'SafetyHealthTraining';

function SAT_BASIC_04F(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);
  const searchInfo = useSelector((state) => state.SearchInfo);

  //로그 관련

  // 교육자료 등록 그리드
  const gridRef1 = useRef(); // 교육현황 그리드
  const [rowData1, setRowData1] = useState([]); // 교육자료 그리드 데이터
  const [selectedRowData1, setSelectedRowData1] = useState([]); // 교육자료 그리드 클릭 시 데이터
  const [changedRowData1, setChangedRowData1] = useState([]); // 교육자료 그리드 변경 시 데이터
  const [deletedRowData1, setDeletedRowData1] = useState([]); // 삭제된 행 데이터
  const selectedRowNosRef = useRef(new Set());
  const lastCheckedIndexRef = useRef(null);
  const currentRowIndexRef = useRef(null);

  // 삭제 PayLoad
  const delete1 = useDelete1();
  const delete2 = useDelete2();

  // 삭제 Handler
  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    deletedRowData: deletedRowData1,
    rowData: rowData1,
    setChangedRowData: setChangedRowData1,
  });

  // 교육대상자 선택 팝업
  const [modalToggle4, setModalToggle4] = useState(false);
  const [modalRowData4, setModalRowData4] = useState([]);
  const [selectedWorkers, setSelectedWorkers] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [currentRowData, setCurrentRowData] = useState(null);

  const [codes, setCodes] = useState({}); // 코드 데이터
  const [eduGubunOptions, setEduGubunOptions] = useState([]); // 교육구분 옵션

  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: changedRowData1,
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.chaebun,
    getKeyFromResult: (result) => result.chaebun,
  });

  // 코드 조회 함수
  const { refetch: SearchCode } = useSearchCode({
    onSuccess: async (rows) => {
      const sheGubunCodes = rows
        .filter((item) => item.groupCd === 'SHE_GUBUN')
        .map((item) => ({
          code: item.code,
          name: item.codeNm,
        }));

      setCodes({ sheGubun: sheGubunCodes });
      setEduGubunOptions(sheGubunCodes.map((item) => item.name));
    },
  });
  const { runAsync: Search2Async } = useSearch2();
  const { runAsync: Search3Async } = useSearch3({
    onSuccess: (rows) => {
      setModalRowData4(rows);
    },
  });
  const { refetch: Search1 } = useSearch1({
    onSuccess: async (rows) => {
      const data = Array.isArray(rows) ? rows : [];

      if (data.length === 0) {
        setRowData1([]);
        dispatch(
          showSnackbar({
            message: '데이터가 없습니다.',
            type: 'info',
          })
        );
        return;
      }

      if (data[0]?.type === 'Error') {
        dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
        return;
      }

      const dataWithTargetNames = await Promise.all(
        data.map(async (raw) => {
          if (!raw.sheId || !raw.sheTargetCount || raw.sheTargetCount === 0)
            return raw;

          try {
            const targetData = await Search2Async({ sheId: raw.sheId });

            if (
              Array.isArray(targetData) &&
              targetData.length > 0 &&
              targetData[0]?.type !== 'Error'
            ) {
              const targetNames = targetData
                .map((t) => t.name || t.userNm || t.id || '')
                .filter(Boolean)
                .sort((a, b) => a.localeCompare(b, 'ko'));

              if (targetNames.length > 0) {
                const targetText =
                  targetNames.length === 1
                    ? targetNames[0]
                    : `${targetNames[0]} 외 ${targetNames.length - 1}명`;

                return {
                  ...raw,
                  eduTarget: targetText,
                  eduTargetIds: targetData
                    .map((t) => t.id || t.userid || '')
                    .filter(Boolean),
                };
              }
            }
          } catch (error) {
            console.error(`교육대상자 조회 실패 (sheId: ${raw.sheId}):`, error);
          }

          return raw;
        })
      );

      setRowData1(dataWithTargetNames);
    },
  });

  const PopupClickEventTarget = async (rowData) => {
    if (!rowData) {
      dispatch(
        showSnackbar({
          message: '데이터가 없습니다.',
          type: 'warning',
        })
      );
      return;
    }

    setCurrentRowData(rowData);
    setSearchKeyword('');
    dispatch(showLoading());

    try {
      const memberList = await Search3Async();

      if (rowData.sheId) {
        const targetData = await Search2Async({ sheId: rowData.sheId });
        const targetIds = (targetData || []).map((t) => t.id).filter(Boolean);

        const selected = memberList.filter((member) =>
          targetIds.includes(member.id)
        );

        setSelectedWorkers(selected);
      } else {
        setSelectedWorkers([]);
      }
    } catch (error) {
      console.error('교육대상자 조회 실패:', error);
      dispatch(
        showSnackbar({
          message: '교육대상자 조회 중 오류가 발생했습니다.',
          type: 'error',
        })
      );
    } finally {
      dispatch(closeLoading());
      setModalToggle4(true);
    }
  };
  const ResetLogicAll = () => {
    setRowData1([]);
    setSelectedRowData1([]);
    setChangedRowData1([]);
    setDeletedRowData1([]);
  };

  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();

  const { run: Save1 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '변경 사항',
    schema: SAT_BASIC_05_Schema,

    getChangedRows: () => changedRowData1.filter((r) => !r.deleteYn),
    getDeletedRows: () => deletedRowData1,

    requestDelete: deleteHandler1.DeleteLogic,

    requestSave: async (rows) => {
      const saveResults = [];

      for (const row of rows) {
        try {
          const saveResponse = await Save1Async([row]);

          const sheId = saveResponse?.data?.[0]?.data?.[0]?.sheId || 0;

          // 2단계: 기존 교육대상자 조회 (신규가 아닌 경우만)
          let existingTargetIds = [];
          const isNewRow = !row.sheId || row.sheId === 0;

          if (!isNewRow) {
            try {
              const existingResult = await Search2Async({ sheId });
              existingTargetIds = (existingResult || [])
                .map((t) => t.id)
                .filter(Boolean);
            } catch (error) {
              console.error('기존 교육대상자 조회 실패:', error);
            }
          }

          // 3단계: 교육대상자 추가/삭제 처리
          const newTargetIds = Array.isArray(row.eduTargetIds)
            ? row.eduTargetIds.filter(Boolean)
            : [];

          const targetIdsToDelete = existingTargetIds.filter(
            (id) => !newTargetIds.includes(id)
          );

          const targetIdsToAdd = newTargetIds.filter(
            (id) => !existingTargetIds.includes(id)
          );
          console.log('targetIdsToDelete:', targetIdsToDelete);
          console.log('targetIdsToDelete.length:', targetIdsToDelete.length);
          // 삭제 처리
          if (targetIdsToDelete.length > 0) {
            const deleteResult = await delete2.runAsync(
              targetIdsToDelete.map((targetId) => ({
                sheId,
                targetId,
              }))
            );

            if (!deleteResult?.data?.[0]?.isSuccess) {
              console.error(
                '교육대상자 삭제 오류:',
                deleteResult?.data?.[0]?.message
              );
            }
          }

          // 추가 처리
          if (targetIdsToAdd.length > 0) {
            const addResult = await Save2Async(
              targetIdsToAdd.map((targetId) => ({
                sheId,
                targetId,
              }))
            );

            if (!addResult?.data?.[0]?.isSuccess) {
              console.error(
                '교육대상자 저장 오류:',
                addResult?.data?.[0]?.message
              );
            }
          }

          // 성공
          saveResults.push({
            ...row,
            isSuccess: true,
            sheId,
          });
        } catch (error) {
          console.error('행 저장 중 오류:', error);
          saveResults.push({
            ...row,
            isSuccess: false,
            errorMessage: error.message || '오류가 발생했습니다.',
          });
        }
      }

      return { data: saveResults };
    },

    reset: ResetLogicAll,
    refresh: Search1,

    partialRefresh: ({ saveResult, changedRows }) =>
      handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: Search1,
      }),
  });

  //#region 나머지 함수
  //인쇄 함수
  const PrintLogic1 = async () => {
    setLoading(true);
    dispatch(showLoading());

    try {
      const searchYear = searchInfo?.year
        ? dayjs(searchInfo.year, 'YYYY').format('YYYY')
        : dayjs().format('YYYY');

      // HeaderData 설정
      const headerData = {
        YEAR: searchYear,
      };

      // TableData 매핑 (레포트 양식에 맞게)
      const tableData = await Promise.all(
        rowData1
          .filter((row) => !row.deleteYn) // 삭제된 행 제외
          .map(async (row, index) => {
            // 교육 구분: 코드를 이름으로 변환
            const sheGubunCode = row.sheGubun || '';
            const codeList = codes?.sheGubun || [];
            const foundCode = codeList.find(
              (item) => item.code === sheGubunCode
            );
            const sheGubunName = foundCode ? foundCode.name : sheGubunCode;

            // 교육대상자: "이름 외 N명" 형식으로 변환
            let eduTargetText = '';
            if (row.eduTarget) {
              // 이미 "이름 외 N명" 형식이면 그대로 사용
              eduTargetText = row.eduTarget;
            } else if (
              row.sheId &&
              row.sheTargetCount &&
              row.sheTargetCount > 0
            ) {
              // 교육대상자 정보 조회
              try {
                const targetData = await Search2Async({ sheId: row.sheId });
                if (
                  Array.isArray(targetData) &&
                  targetData.length > 0 &&
                  targetData[0]?.type !== 'Error'
                ) {
                  // 교육대상자 이름 배열 추출 및 정렬
                  const targetNames = targetData
                    .map((t) => t.NAME || t.USER_NM || '')
                    .filter(Boolean)
                    .sort((a, b) => a.localeCompare(b, 'ko'));

                  if (targetNames.length > 0) {
                    // "이름 외 N명" 형식으로 변환
                    eduTargetText =
                      targetNames.length === 1
                        ? targetNames[0]
                        : `${targetNames[0]} 외 ${targetNames.length - 1}명`;
                  } else {
                    eduTargetText = `${row.sheTargetCount}명`;
                  }
                } else {
                  eduTargetText = `${row.sheTargetCount}명`;
                }
              } catch (error) {
                // 조회 실패 시 SHE_TARGET_COUNT 사용
                console.error(
                  `교육대상자 조회 실패 (sheId: ${row.sheId}):`,
                  error
                );
                eduTargetText = `${row.sheTargetCount}명`;
              }
            } else if (row.sheTargetCount && row.sheTargetCount > 0) {
              eduTargetText = `${row.sheTargetCount}명`;
            }

            // 교육실시여부: ON/OFF를 한글로 변환
            let sheYnText = '';
            if (row.sheYn === 'ON' || row.sheYn === 'on') {
              sheYnText = '실시';
            } else if (row.sheYn === 'OFF' || row.sheYn === 'off') {
              sheYnText = '미실시';
            } else {
              sheYnText = row.sheYn || '';
            }

            return {
              NO: index + 1,
              SHE_GUBUN: sheGubunName, // 교육 구분 (이름)
              SHE_NM: row.sheNm || '', // 교육명
              EDU_TARGET: eduTargetText, // 교육대상자
              SHE_TIME: row.sheTime || 0, // 교육시간
              SHE_YN: sheYnText, // 교육실시여부
            };
          })
      );

      const printData = {
        FileName: 'TRA_BASIC_05',
        HeaderData: JSON.stringify(headerData),
        TableData: JSON.stringify(tableData),
      };

      await Commons.Axios(
        'report',
        Global.base.useUrl + Global.urls.Reports.reports,
        printData
      ).then((response) => {
        const blobUrl = URL.createObjectURL(response.data);
        window.open(blobUrl, '_blank'); // 새 탭에서 열기
      });
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
      dispatch(closeLoading());
    }
  };

  const handleRowSelection = (rowData, rowIndex) => {
    currentRowIndexRef.current = rowIndex;
    // onSelectionChanged에서 처리하므로 여기서는 currentRowIndexRef만 업데이트
    // setSelectedRowData1은 onSelectionChanged에서 처리됨
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  //#endregion

  return (
    <div className="wrap">
      <SAT_BASIC_04
        navigate={navigate}
        userInfo={userInfo}
        lanInfo={lanInfo}
        rowData1={rowData1}
        setRowData1={setRowData1}
        selectedRowData1={selectedRowData1}
        setSelectedRowData1={setSelectedRowData1}
        changedRowData1={changedRowData1}
        setChangedRowData1={setChangedRowData1}
        showSnackbar={showSnackbar}
        dispatch={dispatch}
        filterClick5={props.filterClick5}
        setFilterClick5={props.setFilterClick5}
        searchClick5={props.searchClick5}
        setSearchClick5={props.setSearchClick5}
        addClick5={props.addClick5}
        setAddClick5={props.setAddClick5}
        saveClick5={props.saveClick5}
        setSaveClick5={props.setSaveClick5}
        deleteClick5={props.deleteClick5}
        setDeleteClick5={props.setDeleteClick5}
        printClick5={props.printClick5}
        setPrintClick5={props.setPrintClick5}
        // 함수
        validateSelection={props.validateSelection}
        ResetLogicAll={ResetLogicAll}
        SearchLogic1={Search1}
        SaveLogic1={Save1}
        PrintLogic1={PrintLogic1}
        // GridCheckBox 관련 props
        gridRef={gridRef1}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        RestoreRow1={deleteHandler1.RestoreRow}
        MarkedForDeletion1={deleteHandler1.MarkedForDeletion}
        selectedRowNosRef={selectedRowNosRef}
        lastCheckedIndexRef={lastCheckedIndexRef}
        handleRowSelection={handleRowSelection}
        NewYnErrorMsg={NewYnErrorMsg}
        // 교육대상자 팝업 관련 props
        modalToggle4={modalToggle4}
        setModalToggle4={setModalToggle4}
        modalRowData4={modalRowData4}
        setModalRowData4={setModalRowData4}
        selectedWorkers={selectedWorkers}
        setSelectedWorkers={setSelectedWorkers}
        searchKeyword={searchKeyword}
        setSearchKeyword={setSearchKeyword}
        currentRowData={currentRowData}
        setCurrentRowData={setCurrentRowData}
        SearchLogic4={Search3Async}
        PopupClickEventTarget={PopupClickEventTarget}
        codes={codes}
        eduGubunOptions={eduGubunOptions}
      />
      <Loading open={loading} />
    </div>
  );
}

export default SAT_BASIC_04F;
